<div class="se-timeline-outer-container">
    <div class="se-timeline-container" *ngFor="let year of objectKeys(visitsAndPositions)">
        <div [style.width.px]="retrieveWidth(year)" class="se-timeline-year">
            {{year}}
            <div class="se-timeline-visit-container" *ngFor="let visit of visitsAndPositions[year]" [style.left.px]="visit.position">
                <button (click)="_onItemSelection(visit)">{{visit.description}}</button>
            </div>
        </div>
    </div>
</div>
